import { Injectable } from "@angular/core";
import { Api } from "../base";

import { ChatRoom } from "../../models/chat-room";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FavoriteCastType } from "../../models/favorite";

/** ChatRoomProvider.readAll()の返り値の型 */
export type ChatRoomProviderReadAll = {
  id: number;
  user_id: number;
  already_read_talk_datetime: Date;
};

/** ChatRoomProvider.metUserStatus()の返り値の型 */
export type ChatRoomProviderMetUserStatus = {
  met_count_for_plus_back_rate: number;
  is_met_user: boolean;
};

@Injectable({
  providedIn: "root",
})
export class ChatRoomProvider {
  url = "chat_rooms";

  constructor(private api: Api) {}

  load(
    type: string,
    page: number,
    filter = "",
    favoriteCastType: FavoriteCastType
  ): Observable<ChatRoom[]> {
    return this.api
      .get(this.url + "/" + type, {
        page: page,
        filter: filter,
        favorite_cast_type: favoriteCastType,
      })
      .pipe(map((rooms) => rooms.map((room) => new ChatRoom(room))));
  }

  search(type: string, query: string, filter = ""): Observable<ChatRoom[]> {
    return this.api
      .get(this.url + "/search", { q: query, filter: filter })
      .pipe(map((rooms) => rooms.map((room) => new ChatRoom(room))));
  }

  searchWord(type: string, query: string, filter = ""): Observable<ChatRoom[]> {
    return this.api
      .get(this.url + "/search_word", { word: query, filter: filter })
      .pipe(map((rooms) => rooms.map((room) => new ChatRoom(room))));
  }

  show(chatRoomId: number): Observable<ChatRoom> {
    return this.api
      .get(this.url + "/" + chatRoomId)
      .pipe(map((room) => new ChatRoom(room)));
  }

  searchChatRoomByCastRequestId(requestId: number): Observable<ChatRoom> {
    return this.api
      .get(this.url + "/search_chat_room_by_cast_request", {
        cast_request_id: requestId,
      })
      .pipe(map((room) => new ChatRoom(room)));
  }

  showOrCreateConciergeChatRoom(userId: number): Observable<ChatRoom> {
    return this.api
      .get(this.url + "/show_or_create_concierge_chat_room", {
        user_id: userId,
      })
      .pipe(map((room) => new ChatRoom(room)));
  }

  showOrCreateByUserId(userId: number): Observable<ChatRoom> {
    return this.api
      .post(this.url + "/show_or_create_by_user_id", {
        user_id: userId,
      })
      .pipe(map((room) => new ChatRoom(room)));
  }

  readAll(chatRoomId: number): Observable<ChatRoomProviderReadAll[]> {
    return this.api.post(this.url + "/" + chatRoomId + "/read_all", {});
  }

  favorite(chatRoomId: number): Observable<SuccessJSON> {
    return this.api.post(this.url + "/" + chatRoomId + "/favorite", {});
  }

  deleteFavorite(chatRoomId: number): Observable<null> {
    return this.api.delete(this.url + "/" + chatRoomId + "/favorite");
  }

  hide(chatRoomId: number): Observable<SuccessJSON> {
    return this.api.post(this.url + "/" + chatRoomId + "/hide", {});
  }

  metUserStatus(userId: number): Observable<ChatRoomProviderMetUserStatus> {
    return this.api.get(this.url + "/met_user_status", {
      user_id: userId,
    });
  }
}
